import { Navigate } from "react-router-dom";
import { LAST_ROUTE_KEY } from "../components/feature/Layout/MainLayout";
import { DEFAULT_ROUTE, NAV_ITEMS } from "./navigation";

function isKnownRoute(value: string) {
  return NAV_ITEMS.some(
    (item) =>
      value === item.path ||
      value.startsWith(`${item.path}?`) ||
      value.startsWith(`${item.path}/`),
  );
}

/** Lands the user on their last visited section, falling back to the default. */
export function LandingRedirect() {
  let target = DEFAULT_ROUTE;
  try {
    const stored = localStorage.getItem(LAST_ROUTE_KEY);
    if (stored && isKnownRoute(stored)) target = stored;
  } catch {
    /* ignore storage failures */
  }
  return <Navigate to={target} replace />;
}
